<template>
  <v-container class="container-card">
    <v-card>
      <ExportarListar />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import ExportarListar from "@/components/comissao/deptoAdministrativo/exportarListar/ExportarListar";
export default {
  components: {
    ExportarListar
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Exportar/Listar Comissão");
  }
};
</script>
